import { Box, Tooltip, Typography } from "@material-ui/core";
import { CustomChip } from "components";
import React from "react";

interface CardHeaderProps {
    label?: string;
    status?: string;
    color?: string;
}

// TODO: Add memo
export const CardHeader = ({ label = "-", status, color }: CardHeaderProps) => {
    return (
        <Box display="flex" justifyContent="space-between" alignItems="center">
            <Typography noWrap component="div" variant="subtitle1">
                <Tooltip title={label}>
                    <Box textOverflow="ellipsis" overflow="hidden" fontWeight="fontWeightBold" color="primary">
                        {label}
                    </Box>
                </Tooltip>
            </Typography>
            {status && (
                <Box>
                    <CustomChip bgColor={color} label={status} />
                </Box>
            )}
        </Box>
    );
};
